import styled from "@emotion/styled";
import { fontFredoka, theme } from "@product/scmp-sdk";

import { StyledLogoPosties } from "scmp-app/components/posties/header/common/styles";

import { PostiesEnquires } from "./enquires";
import LogoScmp from "./logo-scmp.svg";
import { PostiesSitemap } from "./sitemap";
import { PostiesSocialMedia } from "./social-media";

export const Container = styled.div`
  padding-block: 40px;
  padding-inline: 24px;

  background: #1b4191;

  ${theme.breakpoints.up("tablet")} {
    padding-block: 48px 32px;
    padding-inline: 48px;
  }
  ${theme.breakpoints.up("desktop")} {
    padding-block: 48px;
    padding-inline: 56px;
  }
  ${theme.breakpoints.up("largeDesktop")} {
    padding-inline: 0;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  max-inline-size: 1280px;
  min-block-size: 416px;
  margin-inline: auto;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;

  margin-block-end: 40px;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    margin-block-end: 56px;
  }
`;

export const LogoPosties = styled(StyledLogoPosties)`
  inline-size: 272px;
  block-size: 43px;
  margin-block-end: 40px;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 339px;
    block-size: 54px;
    margin-block-end: 0;
  }
`;

export const StyledPostiesSocialMedia = styled(PostiesSocialMedia)``;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  inline-size: 100%;
  margin-block-end: 40px;
  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
    justify-content: space-between;

    margin-block-end: 56px;
  }
`;

export const StyledPostiesSitemap = styled(PostiesSitemap)``;

export const StyledPostiesEnquires = styled(PostiesEnquires)`
  border-block-start: 1px solid #ffffff;

  margin-block-start: 32px;
  padding-block-start: 32px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 0;
    margin-inline-start: 32px;
    padding-block-start: 0;
    padding-inline-start: 32px;
    border-block-start: none;
    border-inline-start: 1px solid #ffffff;
  }

  ${theme.breakpoints.up("desktop")} {
    margin-inline-start: 76px;
    padding-inline-start: 76px;
  }
`;

export const LogoCopyrightContainer = styled.div`
  display: flex;
  flex-direction: column;

  margin-block-start: auto;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const StyledLogoScmp = styled(LogoScmp)`
  inline-size: 162px;
  block-size: 16.6px;
  margin-block-end: 16px;
  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 0;
  }
`;

export const Copyright = styled.div`
  color: #ffffff;
  font-weight: 400;
  font-size: 10px;
  font-family: ${fontFredoka};
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  ${theme.breakpoints.up("tablet")} {
    font-size: 12px;
    letter-spacing: -0.12px;
  }
`;
